import * as React from "react";

import { log } from "@lululemon/mwa-utils";
import { Waypoint } from "react-waypoint";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import { Footer } from "@lululemon/footer";

import { setWaypoint } from "../../store/actions/footer";

export function WrappedFooter({ dispatch }) {
  const { query } = useRouter();

  const triggerWaypointChange = React.useCallback(
    (isAboveWaypoint) => {
      dispatch(setWaypoint(isAboveWaypoint));
    },
    [dispatch]
  );

  const handleWaypointPositionChange = React.useCallback(
    (position) => {
      const isInitialPageLoadBelowWaypoint =
        typeof position.previousPosition === "undefined" &&
        position.currentPosition === "inside";
      if (isInitialPageLoadBelowWaypoint) {
        triggerWaypointChange(false);
      }
    },
    [triggerWaypointChange]
  );

  if (query.contentOnly === "true") return null;

  return (
    <Waypoint
      onEnter={() => triggerWaypointChange(false)}
      onLeave={() => triggerWaypointChange(true)}
      onPositionChange={handleWaypointPositionChange}
      bottomOffset="400px"
    >
      <Footer
        onErrorCallback={(error) =>
          log.error("An error occurred when rendering Footer component", error)
        }
      />
    </Waypoint>
  );
}

WrappedFooter.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(WrappedFooter);
